import * as types from '../types'
import socket from '../../helpers/socket'


export function messagesRequest(args) {
    socket.emit('messagesRequest', args)
    return {
        type: types.MESSAGES_REQUEST
    }
}

export function messagesOnReceive(messages) {
    return {
        type: types.MESSAGES_ON_RECEIVE,
        payload: messages
    }
}

export function messagesReceivedUnreadCount(payload) {
    return {
        type: types.MESSAGES_RECEIVED_UNREAD_COUNT,
        payload: payload
    }
}

export function messageOnReceiveNew(payload) {
    return (dispatch, getState) => {
        const contactModals = getState().contactReducer.contactModals;
        const contactModalsHidden = getState().contactReducer.contactModalsHidden;
        dispatch({
            type: types.MESSAGE_ON_RECEIVE_NEW,
            payload: {
                contactModals:contactModals,
                contactModalsHidden:contactModalsHidden,
                message:payload
            }
        });
    }
}

export function messagesOnMarkRead(payload) {
    return {
        type: types.MESSAGES_ON_MARK_READ,
        payload: payload
    }
}

export function messageOnSend(payload) {
    socket.emit('messageSend', payload);
    return {
        type: types.MESSAGES_ON_SEND,
        payload: {to: payload.to}
    }
}

export function messagesOnSeen(payload) {
    return {
        type: types.MESSAGES_ON_SEEN,
        payload: payload
    }
}

export function messagesFileRequest(payload) {
    socket.emit('messagesFileRequest', payload)
    return {
        type: types.MESSAGES_FILE_REQUEST,
        payload: payload
    }
}

export function messagesFileCancel(payload) {
    socket.emit('messagesFileCancel', payload)
    return {
        type: types.MESSAGES_FILE_CANCEL,
        payload: payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/chat/messageActions.js